/**
 * profileCompletion — THE frontend mirror of the §7.17 (DEV-1484) singular
 * profile-completion predicate: **avatar + cover photo + short bio**.
 *
 * Server lockstep: `OnboardingRung.RungBasicsCompleteAsync` (which also
 * requires display name) and the `profile_completed` fact detector in
 * `ImpactEmission`. Every frontend consumer — the AC checklist evaluator,
 * the ring predicate, the profile guidance strip/rings — derives from THIS
 * helper so "complete" can never mean different things on different
 * surfaces (the co-founder finding behind DEV-1484).
 *
 * Accepts both wire casings (snake/camel), like ringStatus.
 */

export interface ProfileCompletionState {
  photo: boolean;
  cover: boolean;
  bio: boolean;
  complete: boolean;
  /** 0–3, for the "n of 3 done" strip. */
  doneCount: number;
}

const has = (v: unknown): boolean => Boolean(v && String(v).trim());

export function profileCompletion(
  user: Record<string, any> | null | undefined,
): ProfileCompletionState {
  const photo = has(user?.profile_image_url ?? user?.profileImageUrl);
  const cover = has(user?.hero_image_url ?? user?.heroImageUrl);
  const bio = has(user?.notes);
  const doneCount = (photo ? 1 : 0) + (cover ? 1 : 0) + (bio ? 1 : 0);
  return { photo, cover, bio, complete: photo && cover && bio, doneCount };
}
